<template>
    <simple-layout-v2
        :models-loaded="true"
        :headerHeight="0"
        class="page-size"
        id="overview-layout"
    >
        <ns-loader
            ref="nsLoader"
            :to-load="toLoad"
            :scoped="false"
            @dataFetched="onDataFetched"
        >
            <loading-template slot="loader"></loading-template>
            <div slot="content">
                <page-display
                    :total-pages="totalPages"
                    :current-page="currentPage"
                    @change-current-page="changeCurrentPage"
                ></page-display>
                <div class="legend"><p class="legend-bold">Legend :</p>
                    <div  class="color-status">
                        <span class="green-trait"></span>
                        <p class="taker-status">Taker connected</p>
                    </div>
                    <div  class="color-status">
                        <span class="white-trait"></span>
                        <p class="taker-status">Taker blanked</p>
                    </div>
                    <div  class="color-status">
                        <span class="yellow-trait"></span>
                        <p class="taker-status">Taker not connected</p>
                    </div>
                    <div  class="color-status">
                        <span class="blue-trait"></span>
                        <p class="taker-status">Taker not configured</p>
                    </div>
                </div>
                <channel-overview-page
                    :key="currentPage"
                    :channels-to-display="channelsToDisplay"
                    :schedulings="schedulings"
                >
                </channel-overview-page>
            </div>
        </ns-loader>
    </simple-layout-v2>
</template>

<script>
import PageDisplay from './page-display.vue';
import channelOverviewPage from './channel-overview-page.vue';
import SimpleLayoutV2 from 'fundation-app-vuejs/src/components/partials/simple-layout-v2';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import LoadingTemplate from '../../partials/ns-loader-template.vue';
export default {

    name: 'index',

    components:{
        SimpleLayoutV2,
        NsLoader,
        PageDisplay,
        LoadingTemplate,
        channelOverviewPage
    },

    data () {
        return {
            schedulings: [],
            channelPerPage: this.$store.getters.monitoringChannelsPerPage,
            currentPage: 1,
            channelSupervisions: [],


        };
    },
    computed:{
        toLoad (){
            return [
                {
                    name: 'schedulings',
                    model: 'schedulings',
                    filters: {
                        status__in: 'PENDING,RUNNING',
                        ordering: 'start_date',
                        archived: false,
                    }
                },
                {
                    name: 'channelSupervisions',
                    model: 'channelSupervisions',
                    filters: {
                        c_resp_nested: true,
                        channel__archived: false,
                        ordering: 'channel_display_name',
                        'channel__status__in': 'AVAILABLE,PREPARING,RUNNING,START_REQUESTED,STARTING,STOP_REQUESTED,STOPPING,STOPPED',
                    },
                },
            ];
        },
        channelsToDisplay() {
            if (!this.channelSupervisions || this.channelSupervisions.length === 0) return [];
            // Filter channels by current Page
            let channelsByCurrentPage = this.channelSupervisions.filter(supervision => supervision.channel.overview_page_number === this.currentPage);

            return channelsByCurrentPage;
        },
        totalPages(){
            let mappedOverviewPageNumbers = this.channelSupervisions.map(channelSupervision => channelSupervision.channel.overview_page_number);
            let maxPageNumber = Math.max(...mappedOverviewPageNumbers);
            return maxPageNumber;
        },
    },

    methods:{
        onDataFetched (res){
            this.$set(this, 'schedulings', res.schedulings);
            this.$set(this, 'channelSupervisions', res.channelSupervisions);
        },
        changeCurrentPage(){
            if(this.totalPages === this.currentPage){
                this.currentPage = 1;
            } else {
                this.currentPage +=1;
            }
        },
    }
};
</script>

<style lang="css" scoped>
.page-size{
    position: absolute;
    margin-left: 0;
    margin-top: 0;
    height: 100% !important;
    z-index: 9999;
}
.legend{
    padding: 18px;
    display: flex;
}

.legend-bold{
    font-weight: 600;
    margin-right: 10px;
}

.legend span{
    width: 22px;
}

.red-trait{
    border: 1px solid #F56C6C;
    margin: 0 7px 10px 0;
}
.yellow-trait{
    border: 1px solid #FFDC42;
    margin: 0 7px 10px 0;
}
.green-trait{
    border: 1px solid #31BD9B;
    margin: 0 7px 10px 0;
}
.white-trait{
    border: 1px solid white;
    margin: 0 7px 10px 0;
}
.blue-trait{
    border: 1px solid #409EFF;
    margin: 0 7px 10px 0;
}
.color-status{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
}
.taker-status{
    font-size: 16px;
    line-height: 19px;
    font-weight: 400;
    padding:0 30px 0 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/ChannelsOverview/index.vue